(function () {
	document.addEventListener("click", function (event) {
		const button = event.target.closest("[data-fulfillment]");
		if (!button) return;
		const method = button.dataset.fulfillment;
		localStorage.setItem("zapiet_fulfillment_method", method);
				window.location.href = "https://www.artsbakeryglendale.com/pages/collections";

	});
})();

window.ZapietEvent.listen("widget_loaded", function () {
	document.addEventListener("click", function (event) {
		const button = event.target.closest("[data-fulfillment]");
		if (!button) return;
		const method = button.dataset.fulfillment;
		localStorage.setItem("zapiet_fulfillment_method", method);
	});
	function initZapietAutoSelect() {
		const method = localStorage.getItem("zapiet_fulfillment_method");
		if (!method) return;
		const el = document.querySelectorAll(".checkoutMethod");
        const start = Date.now();
        const interval = setInterval(() => {
            if (method === "pickup") {
                if (el[0]) {
                    el[0].click();
                }
            }
            if (method === "delivery") {
                if (el[1]) {
                    el[1].click();
                }
            }
            if (Date.now() - start > 5000) {
                clearInterval(interval); 
            }
        }, 100);
	}
	initZapietAutoSelect();
});




